// Keep this scoped to the series: a newly loaded chart must receive its first tick.
export function createLiveTickIdentity() {
  let previousSeries;
  let previousValues;
  return (series, tick) => {
    const values = [tick.s, tick.t, tick.o, tick.h, tick.l, tick.c, tick.v, tick.ask,
      tick.requestId, tick.timeFrame, tick.ohlcComplete, tick.volumeAvailable];
    if (previousSeries === series && previousValues &&
        values.every((value, index) => Object.is(value, previousValues[index]))) return false;
    previousSeries = series;
    previousValues = values;
    return true;
  };
}
